import React from 'react';
import Box from '@mui/material/Box';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';

import type { PricingMode, WizardState } from './types';

interface PricingStepProps {
  state: WizardState;
  updateState: (patch: Partial<WizardState>) => void;
}

const PricingStep = ({ state, updateState }: PricingStepProps) => (
  <Box sx={{ display: 'flex', gap: 4, alignItems: 'flex-start' }}>
    <Box sx={{ flex: 1 }}>
      <Typography variant="body1" sx={{ mb: 2 }}>
        How should override prices be pre-filled?
      </Typography>

      <RadioGroup
        value={state.pricingMode}
        onChange={(_e, value) => updateState({ pricingMode: value as PricingMode })}
      >
        <FormControlLabel
          value="blank"
          control={<Radio />}
          label="Leave blank — I'll enter prices myself"
        />
        <FormControlLabel
          value="resalePrice"
          control={<Radio />}
          label="Pre-fill with the current base resale price"
        />
        <FormControlLabel
          value="percentOff"
          control={<Radio />}
          label="Pre-fill with a percentage off the base resale price"
        />
      </RadioGroup>
    </Box>

    {state.pricingMode === 'percentOff' && (
      <TextField
        label="% off base price"
        type="number"
        value={state.percentOff || ''}
        onChange={(e) => {
          const val = parseInt(e.target.value, 10);
          updateState({ percentOff: Number.isNaN(val) ? 0 : val });
        }}
        inputProps={{ min: 1, max: 100 }}
        sx={{ width: 200, mt: 4 }}
      />
    )}
  </Box>
);

export default PricingStep;
